import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useGame } from "context/GameContext";
import Row from "./components/caravan/row";
import Chevron from "./components/caravan/chevron";
import Work from "model/caravan/work";
import "./Caravan.css";

const message = (caravan) => {
  const startBonuses = caravan.bonuses();

  const consumption =
    `**${caravan.eat()} food** and **${caravan.drink()} water**`;
  const startBonus =
    `**${startBonuses.food} food**, **${startBonuses.coins} coins** and **${startBonuses.ammo} ammo**`;
  const resilience =
    `**${caravan.starvation()} health** when starving and **${caravan.dehydration()} health** when dehydrated.`;
  return `Our caravan will consume ${consumption} per day. Our members will bring an extra ${startBonus} on the trip.
		When times are tough, we will lose ${resilience}`;
};

const Caravan = ({ className }) => {
  const { gameState, setGameState } = useGame();
  const { party } = gameState;
  const caravan = party.caravan;

  const [props, setProps] = useState(message(party.caravan));

  useEffect(() => {
    // Update the caravan message whenever the caravan changes
    if (caravan) {
      setProps(message(caravan));
    }
  }, [caravan]);

  const changeMember = (job, add) => {
    const delta = add ? 1 : -1;
    caravan.update(job, delta);

    // Update the gameState with the modified caravan
    setGameState((prev) => {
      prev.party.caravan = caravan;
      return {
        ...prev,
      };
    });
  };

  const changeWork = (background, work, add) => {
    const delta = add ? 1 : -1;
    caravan.updateWork(background, work, delta);
    // Update the gameState with the modified caravan
    setGameState((prev) => {
      prev.party.caravan = caravan;
      return {
        ...prev,
      };
    });
  };

  if (!caravan) return null;

  const jobs = caravan.jobs();
  const isFull = caravan.isFull();

  const departed = party.started();
  return (
    <div className="container">
      <ReactMarkdown>{props}</ReactMarkdown>
      <div className="caravanType">
        {`Current travel method: ${caravan.travelMethod()}`}
      </div>

      <div
        className={`caravan_container ${className}`}
        style={{ position: departed ? "relative" : "absolute" }}
      >
        <div className="caravan">
          {jobs.map((job, i) => {
            const members = caravan.job(job);
            return (
              <Row
                key={i}
                job={job}
                count={members}
                withButtons={departed}
                isFull={isFull}
                onIncrease={() => changeMember(job, true)}
                onDecrease={() => changeMember(job)}
              />
            );
          })}
          <div className="caravanSize">
            {`party ${caravan.size()}/${caravan.max()}`}
          </div>
        </div>

        {departed && (
          <div className="work">
            <div className="workTypes">
              <span>{`foraging`}</span>
              <span>{`crafting`}</span>
              <span>{`fabricating`}</span>
            </div>

            {jobs.map((bg, i) => {
              const total = caravan.job(bg);
              const workers = caravan.workers(bg);
              const foraging = caravan.workersInAJob(bg, Work.forage);
              const crafting = caravan.workersInAJob(bg, Work.craft);
              const fabricating = caravan.workersInAJob(bg, Work.fabricate);
              return (
                <div key={i} className="work_areas">
                  <div className="work_row">
                    <span>{foraging}</span>
                    <span className="work_controls">
                      <Chevron
                        isUp
                        onClick={() => changeWork(bg, Work.forage, true)}
                        disabled={workers >= total}
                      />
                      <Chevron
                        onClick={() => changeWork(bg, Work.forage)}
                        disabled={foraging === 0}
                      />
                    </span>
                  </div>
                  <div className="work_row">
                    <span>{crafting}</span>
                    <span className="work_controls">
                      <Chevron
                        isUp
                        onClick={() => changeWork(bg, Work.craft, true)}
                        disabled={workers >= total}
                      />
                      <Chevron
                        onClick={() => changeWork(bg, Work.craft)}
                        disabled={crafting === 0}
                      />
                    </span>
                  </div>
                  <div className="work_row">
                    <span>{fabricating}</span>
                    <span className="work_controls">
                      <Chevron
                        isUp
                        onClick={() => changeWork(bg, Work.fabricate, true)}
                        disabled={workers >= total}
                      />
                      <Chevron
                        onClick={() => changeWork(bg, Work.fabricate)}
                        disabled={fabricating === 0}
                      />
                    </span>
                  </div>
                </div>
              );
            })}

            <div className="workSize">
              {`working ${caravan.work.numWorkers}/${caravan.size()}`}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Caravan;
